export const module5InitialState = {
  module5: {
    name: 'Distance',
    stepCompleted: 'notstarted',
sectionCompleted: 0,
    StudentID: '',
    moduleID: '',
    keys: 0,
    learnIcon: false,
    practiceIcon: false,
    celebrateIcon: false,
    reviewIcon: false,
    cameraIcon: false,
    singingIcon: false,
    currentday: 1,
    cameraOpen: false,
    userRecordedVideos: false,
    game_details: {},
    day_completed: 0,
    rewards: {
      TreeHouseRed: false,
      TreeHouseBlue: false,
      Swing: false,
      TireSwing: false,
      Ladder: false,
      Stairs: false,
      ButterflyBlue: false,
      ButterflyPink: false,
      TelescopeRed: false,
      TelescopeBlue: false,
      DuckColored: false,
      DuckWhite: false,
      Deer: false,
      Doe: false,
      BirdRed: false,
      BirdBlue: false,
      HardHat: false,
      Goggles: false,
    },
    unlockedDays: {
      day1: true,
      day2: false,
      day3: false,
      day4: false,
      day5: false,
      day6: false,
      day7: false,
      day8: false,
      day9: false,
    },
  },
};

export const Module5Reducer = (state = module5InitialState, action) => {
  switch (action.type) {
    case 'SET_MODULE5_INITIALSTATE': {
      let step = 'notstarted';
      if (action.payload?.step_completed != null) {
        step = action.payload?.step_completed;
      }
      let day = 0;
      if (action.payload?.day_completed != null) {
        day = action.payload?.day_completed;
      }

      // map through the object and set the rewards to true
      const tempRewards = {
        TreeHouseRed: false,
        TreeHouseBlue: false,
        Swing: false,
        TireSwing: false,
        Ladder: false,
        Stairs: false,
        ButterflyBlue: false,
        ButterflyPink: false,
        TelescopeRed: false,
        TelescopeBlue: false,
        DuckColored: false,
        DuckWhite: false,
        Deer: false,
        Doe: false,
        BirdRed: false,
        BirdBlue: false,
        HardHat: false,
        Goggles: false,
      };
      let tempObj = action.payload?.game_details;
      if (tempObj != 'null') {
        const obj = JSON.parse(tempObj)?.dailyRewards;
        for (let i = 0; i < obj.length; i++) {
          for (let j = 0; j < Object.keys(tempRewards).length; j++) {
            if (obj[i]?.type === Object.keys(tempRewards)[j]) {
              tempRewards[Object.keys(tempRewards)[j]] = true;
            }
          }
        }
      } else {
        tempObj = '{"moduleFlags":[],"dailyRewards":[]}';
      }

      const tempUnlockedDays = {
        day1: true,
        day2: false,
        day3: false,
        day6: false,
        day5: false,
        day6: false,
        day7: false,
        day8: false,
        day9: false,
      };
      if (action.payload?.day_completed != null) {
        for (let i = 1; i <= action.payload?.day_completed + 1; i++) {
          tempUnlockedDays[`day${i}`] = true;
        }
      }
      // "{\"moduleFlags\":[{\"flag\":\"InProgress\",\"lastUpdated\":\"2021-05-23T07:46:45.95Z\"},{\"flag\":\"WatchedSurprise\",\"lastUpdated\":\"2021-05-23T07:45:41.51Z\"}],\"dailyRewards\":[{\"type\":\"SurfBoardRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"UmbrellaGreen\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachChairRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"FloatationInnerTube\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"OceanWhale\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SandBucket\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"SeashellsRed\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"BeachwearSandles\",\"x_multiplier\":1,\"y_multiplier\":1},{\"type\":\"CrabWearMustash\",\"x_multiplier\":1,\"y_multiplier\":1}]}"
      // "{\"moduleFlags\":[],\"dailyRewards\":[]}"

      return {
        ...state,
        module5: {
          ...state.module5,
          StudentID: action.payload?.student_id,
          stepCompleted: step,
          moduleID: action.payload?.id,
          unlockedDays: tempUnlockedDays,
          rewards: tempRewards,
          day_completed: day,
          game_details: JSON.parse(tempObj),
        },
      };
    }

    case 'CLEAR': {
      return {
        ...module5InitialState,
      };
    }
    case 'MODULE5_SET_DAY': {
      return {
        ...state,
        module5: {
          ...state.module5,
          currentday: action.payload,
          keys: 0,
        },
      };
    }

    case 'MODULE5_SET_GameDetials': {
      return {
        ...state,
        module5: {
          ...state.module5,
          game_details: action.payload,
        },
      };
    }

    case 'MODULE5_SET_stepCompleted': {
      return {
        ...state,
        module5: {
          ...state.module5,
          stepCompleted: action.payload,
        },
      };
    }

    case 'MODULE5_SET_dayCompleted': {
      return {
        ...state,
        module5: {
          ...state.module5,
          day_completed: action.payload,
        },
      };
    }

    case 'MODULE5_SET_CAMERAOPEN': {
      return {
        ...state,
        module5: {
          ...state.module5,
          cameraOpen: action.payload,
        },
      };
    }
    case 'MODULE5_SET_KEY': {
      return {
        ...state,
        module5: {
          ...state.module5,
          keys: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_PRACTICE_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          practiceIcon: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_CAMERA_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          cameraIcon: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_SINGING_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          singingIcon: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_LEARN_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          learnIcon: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_CELEBRATE_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          celebrateIcon: action.payload,
        },
      };
    }
    case 'MODULE5_TOGGLE_REVIEW_ICON': {
      return {
        ...state,
        module5: {
          ...state.module5,
          reviewIcon: action.payload,
        },
      };
    }
    case 'MODULE5_SET_REWARD11': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            TreeHouseRed: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD12': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            TreeHouseBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD21': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Swing: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD22': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            TireSwing: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD31': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Ladder: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD32': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Stairs: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD41': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            ButterflyPink: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD42': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            ButterflyBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD51': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            TelescopeBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD52': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            TelescopeRed: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD61': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            DuckWhite: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD62': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            DuckColored: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD71': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Deer: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD72': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Doe: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD81': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            BirdBlue: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD82': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            BirdRed: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD91': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            HardHat: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_REWARD92': {
      return {
        ...state,
        module5: {
          ...state.module5,
          rewards: {
            ...state.module5.rewards,
            Goggles: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK1': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day1: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK2': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day2: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK3': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day3: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK4': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day4: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK5': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day5: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK6': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day6: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK7': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day7: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK8': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day8: action.payload,
          },
        },
      };
    }
    case 'MODULE5_SET_DAY_UNLOCK9': {
      return {
        ...state,
        module5: {
          ...state.module5,
          unlockedDays: {
            ...state.module5.unlockedDays,
            day9: action.payload,
          },
        },
      };
    }
    default:
      return state;
  }
};
export default Module5Reducer;
